import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-privacy-policy-page',
  imports: [],
  templateUrl: './privacy-policy-page.html',
  styleUrl: './privacy-policy-page.scss',
})
export class PrivacyPolicyPage implements OnInit {
  constructor(private titleService: TitleService) {}

  ngOnInit(): void {
    this.titleService.setTitle('Privacy Policy');
  }

  get appname(): string {
    return environment.appname;
  }

  get email(): string {
    return environment.email;
  }
  get address1(): string {
    return environment.address1;
  }

  get address2(): string {
    return environment.address2;
  }
}
